import { PROFILE_TYPE_DESCRIPTION, AddableProfileType } from 'utils/profile-eligibility'
import ProfileTypePicker, { ProfileTypeOption } from 'components/profile-type-picker'

interface Props {
  addableTypes: AddableProfileType[]
  onSelect: (t: AddableProfileType) => void
}

// Reason shown in place of the action description when a type cannot be added.
// Youth is never disabled (a guardian can have multiple children).
const DISABLED_REASON: Record<AddableProfileType, string> = {
  player: 'You already have a Player profile',
  coach: 'You already have a Coach profile',
  youth: ''
}

const ALL_TYPES: AddableProfileType[] = ['player', 'coach', 'youth']

const StepPickType = ({ addableTypes, onSelect }: Props) => {
  const options: ProfileTypeOption[] = ALL_TYPES.map(t => {
    const isEnabled = addableTypes.includes(t)
    return {
      type: t,
      description: PROFILE_TYPE_DESCRIPTION[t],
      disabled: !isEnabled,
      disabledReason: DISABLED_REASON[t]
    }
  })

  return (
    <ProfileTypePicker
      value={null}
      onChange={onSelect}
      options={options}
    />
  )
}

export default StepPickType
